import {
  CanActivateChildFn,
  CanActivateFn,
  Router,
} from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';

import { AuthService } from './auth.service';

function requireAuthentication(url: string) {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.ensureSession().pipe(
    map((authenticated) =>
      authenticated
        ? true
        : router.createUrlTree(['/login'], {
            queryParams: {
              returnUrl: normalizeReturnUrl(url),
            },
          }),
    ),
  );
}

export const authGuard: CanActivateFn = (_route, state) =>
  requireAuthentication(state.url);

export const authChildGuard: CanActivateChildFn = (_route, state) =>
  requireAuthentication(state.url);

export const anonymousGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.ensureSession().pipe(
    map((authenticated) => (authenticated ? router.createUrlTree(['/']) : true)),
  );
};

function normalizeReturnUrl(url: string): string {
  if (!url.startsWith('/') || url.startsWith('//') || url === '/login') {
    return '/';
  }

  return url;
}
